<template>
    <FormInput :dati='info'
                 :formlabel="label"
                 :stilestruttura="style"
                 :idform="idform"
                 :action="action"
                 :recaptcha="recaptcha"
                 ref="input"
                 @selectChanged="updatedProdotti">
      </FormInput>

      <div class="" style="width: 66%">
          <div class="form-label block text-gray-700 text-sm mb-2 required">Prodotti Ddt</div>
          <div class="my-3">
            <FloatLabel class="w-full" variant="on">
              <AutoComplete v-model="barcode" forceSelection optionLabel="nome" ref="autocomplete" :suggestions="productSuggestion" @complete="cercaCodice" id="barcode" @option-select="caricaProdotto"/>
              <label for="barcode"> {{ $root.trans.cerca_codice_a_barre }} </label>
            </FloatLabel>
          </div>
          <div class="">
              <div class="">
                  <div style="border: 1px solid lightgray">
                      <table class="table text-center">
                          <thead>
                          <tr>
                              <th class="fs-5" style="position: sticky; top: 0; background: white;">Sku</th>
                              <th class="fs-5" style="position: sticky; top: 0; background: white;">Nome</th>
                              <th class="fs-5" style="position: sticky; top: 0; background: white;">Unità di Misura</th>
                              <th class="fs-5" style="position: sticky; top: 0; background: white;">Quantità</th>
                              <th class="fs-5" style="position: sticky; top: 0; background: white;">Disponibili</th>
                          </tr>
                          </thead>
                          <tbody id="tabella_prodotti">
                            <tr v-for="(prodotto, index) in prodotti" :key="index">
                                
                                <td>{{ prodotto.sku }}</td>
                                <td>{{ prodotto.nome }}</td>
                                <td>{{ prodotto.unita_misura }}</td>
                                <td>
                                  <InputNumber v-model="prodotto.quantita" :min="1" :max="prodotto.disponibili" :minFractionDigits="0" fluid buttonLayout="horizontal" @value-change="updateProdottiJson"/>
                                </td>
                              <td>{{ prodotto.disponibili }}</td>
                            </tr>
                          </tbody>
                      </table>
                  </div>
              </div>
          </div>
      </div>
  
      <div class="text-right">
          <a v-if="cancel !== ''" type="button" class="p-button p-component p-button-secondary"
               :href="cancel">{{ bottoneannulla }}</a>
          <button @click="salvabozza" class="p-button p-component p-button-success">
              <span class="p-button-label">{{ bottonesalvabozza }}</span>
          </button>
          <button @click="salva" class="p-button p-component p-button-success">
              <span class="p-button-label">{{ bottonesalva }}</span>
          </button>

          <template v-if="bottonesalvacontinua !== ''">
              <button @click="$refs.input.checkForm(1)"
                              class="p-button p-component p-button-secondary">
                  <span class="p-button-label">{{ bottonesalvacontinua }}</span>
              </button>
          </template>
      </div>
  </template>
  
  <script>
  
  import InputNumber  from 'primevue/inputnumber';
import FormInput from './FormInput.vue';
import { JsonRequestError } from '@fullcalendar/core/index.js';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import AutoComplete from 'primevue/autocomplete';
import { isArray } from 'chart.js/helpers';
  
  export default {
    name: "DdtForm",
    components: {
      FormInput,
      FloatLabel,
      AutoComplete,
      InputNumber
    },
    props: [
      'dati',
      'struttura',
      'azione',
      'annulla',
      'stilestruttura',
      'id',
      'prodottijson',
      'recaptcha',
      'bottonesalva',
      'bottonesalvabozza',
      'bottonesalvacontinua',
      'bottoneannulla',
      'route_prodotti',
      "rotta_codice"
    ],
    data() {
      return {
        cancel: this.annulla,
        action: this.azione,
        info: JSON.parse(this.dati),
        label: JSON.parse(this.struttura),
        style: this.stilestruttura,
        errors: {},
        imginput: false,
        idform: this.id,
        prodotti: JSON.parse(this.prodottijson),
        prodotti_route: this.route_prodotti,
        codebar_route: this.rotta_codice,
        barcode: '',
        productSuggestion: [],
        value:"",
        items: [],
      };
    },
    beforeMount() {
      if (typeof this.id == "undefined") {
        this.idform = 'maschera';
      } else {
        this.idform = this.id;
      }
  
    },
    mounted() {

      document.addEventListener('formChanged', function(e){
        this.label = e.detail.newStruttura;
      });
  
    },
    methods: {
      caricaProdotto(e){
        axios.post(route(this.codebar_route,{barcode: e.value.barcode}))
        .then(res => {
          if(res.data.id){
            if(isArray(this.info['prodotti_id'])){
              if(!this.info['prodotti_id'].includes(res.data.id)){
                this.prodotti.push(res.data);
                this.info['prodotti_id'].push(res.data.id);
              }
            } else {
              this.prodotti.push(res.data);
              this.info['prodotti_id'] = [res.data.id];
            }
            this.barcode = '';
          } else {
            this.$toast.add({severity:'error', summary: 'Errore', detail: 'Prodotto non trovato', life: 3000});
          }
        })
        
      },
      cercaCodice(e){

          const options = [];
          for(let i = 0; i < this.label['prodotti_id'][3].length; i++){
            options.push({...this.label['prodotti_id'][3][i]});
          }
          if (!e.query.trim().length) {
            this.productSuggestion = [...options];
          } else {
            this.productSuggestion = options.filter((product) => {
                  return product.barcode && product.barcode.toLowerCase().startsWith(e.query.toLowerCase());
              });
          }
          console.log(this.productSuggestion);

          if( this.productSuggestion.length == 1){
            this.barcode = this.productSuggestion[0].barcode;
            this.caricaProdotto({value: this.productSuggestion[0]});
          }
       
      },
      updatedProdotti(e,k){
        if(k == 'prodotti_id'){
          const ids = e.value;
          if(!ids || ids.length == 0){
            this.prodotti = [];
            return;
          }
          axios.post(route(this.prodotti_route,{prodotti_ids: ids, sede_id: this.info.id}))
          .then(res => {
            this.prodotti = res.data;
          });
        }
      },
      updateProdottiJson(){
        const prodotti_to_send = this.prodotti.map(p => {
          return {
            id: p.id,
            quantita: p.quantita
          }
        });
        this.info.prodotti_json = JSON.stringify(prodotti_to_send);
      },
      salvabozza(){
        this.info.bozza = 1;
        this.$refs.input.checkForm(0);
      },
      salva(){
        this.info.bozza = 0;
        this.$refs.input.checkForm(0);
      }
    }
  }
  </script>
  
  <style scoped>
  
  </style>